import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GseUserActiveAlarmsComponent } from './gse-user-active-alarms.component';
import { CenteredMessageModule } from '../centered-message/centered-message.module';

import { MatTabsModule } from '@angular/material/tabs';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { TacticalDashboardOverviewGaugeModule } from '../tactical-dashboard-overview-gauge/tactical-dashboard-overview-gauge.module';
import { LoadingSpinnerModule } from '../loading-spinner/loading-spinner.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from 'projects/desktop/src/app/_other-modules/material.module';
import { TacticalNavigationModule } from '../tactical-navigation/tactical-navigation.module';
import { ChartTypeSliderModule } from '../chart-type-slider/chart-type-slider.module';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { NgxResize } from 'ngxtension/resize';

@NgModule({
  declarations: [
    GseUserActiveAlarmsComponent
  ],
  imports: [
    CommonModule,
    CenteredMessageModule,
	NgxResize,
    MatTabsModule,
    MatTooltipModule,
    LoadingSpinnerModule,
    ChartsModule,
	MaterialModule,
	TacticalNavigationModule,
	TacticalDashboardOverviewGaugeModule,
	ChartTypeSliderModule,
	TourMatMenuModule,
  ],
  exports: [
    GseUserActiveAlarmsComponent
  ]
})
export class GseUserActiveAlarmsModule { }
